import { createMapper, Module, Mutations } from 'vuex-smart-module'
import { Vue } from 'vue-property-decorator'
import { MaintenanceInfo } from 'interfaces/notifications'

class NotificationsState {
  maintenanceInfo: MaintenanceInfo | null = null
}

class NotificationsMutations extends Mutations<NotificationsState> {
  setMaintenanceInfo(info: MaintenanceInfo | null) {
    Vue.set(this.state, 'maintenanceInfo', info)
  }
}

export const notifications = new Module({
  state: NotificationsState,
  mutations: NotificationsMutations
})

export const notificationsMapper = createMapper(notifications)
